import { Box } from '@mui/material';
import { FC } from 'react';
import { FieldProps, TextField, useFieldHelper } from 'framework/ui/field';
import { formatPeriod, formatCustomPeriod, formatChangeRequestAlias } from '../../billingUtils';

interface PeriodicPeriodFieldProps extends FieldProps {
  periodSource?: string;
  startDateSource?: string;
  endDateSource?: string;
  changeRequestAliasSource?: string;
}

const PeriodicPeriodField: FC<PeriodicPeriodFieldProps> = props => {
  const { periodSource, startDateSource, endDateSource, changeRequestAliasSource } = props;

  const { getValue } = useFieldHelper<string>({ source: props.source });
  const { getValue: getPeriodMonth } = useFieldHelper<string>({ source: periodSource || '' });
  const { getValue: getStartDate } = useFieldHelper<string>({ source: startDateSource || '' });
  const { getValue: getEndDate } = useFieldHelper<string>({ source: endDateSource || '' });
  const { getValue: getChangeRequestAlias } = useFieldHelper<string>({
    source: changeRequestAliasSource || '',
  });

  const position = getValue();
  const periodMonth = getPeriodMonth();
  const startDate = getStartDate();
  const endDate = getEndDate();
  const changeRequestAlias = getChangeRequestAlias();

  if (changeRequestAlias) {
    return <TextField {...props} value={formatChangeRequestAlias(changeRequestAlias)} label="" />;
  }

  // CALENDAR_PERIOD
  if (periodMonth) {
    return <Box display="flex">{formatPeriod(position, periodMonth)}</Box>;
  }

  // CUSTOM_PERIOD
  if (startDate && endDate) {
    return <Box display="flex">{formatCustomPeriod(startDate, endDate)}</Box>;
  }

  return <Box display="flex">Period {position}</Box>;
};

export default PeriodicPeriodField;
